export const USER_SYSTEM_FEATURE_CATEGORIES = Object.freeze({
    COMPONENT: 'component',
    EXTENSION: 'extension',
});

export const USER_SYSTEM_FEATURE_ACTIVATION = Object.freeze({
    ALWAYS: 'always',
    USER: 'user',
    ADMIN: 'admin',
});

const ACCOUNT_ROLE_GROUPS = Object.freeze(['customer', 'employee', 'service_provider', 'guest']);
const NON_GUEST_ROLE_GROUPS = Object.freeze(['customer', 'employee', 'service_provider']);

export const USER_SYSTEM_FEATURES = Object.freeze([
    {
        id: 'tickets',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Tickets',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.ALWAYS,
        roleGroups: ACCOUNT_ROLE_GROUPS,
    },
    {
        id: 'relationships',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Relationships',
        field: 'customer_relationships_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: NON_GUEST_ROLE_GROUPS,
    },
    {
        id: 'positions',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Positions',
        field: 'customer_positions_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: NON_GUEST_ROLE_GROUPS,
        forcedForRoleGroups: ['service_provider'],
    },
    {
        id: 'timeline',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Timeline',
        field: 'customer_timeline_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: NON_GUEST_ROLE_GROUPS,
        forcedForRoleGroups: ['service_provider'],
    },
    {
        id: 'file_manager',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'File manager',
        field: 'customer_file_manager_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: ACCOUNT_ROLE_GROUPS,
    },
    {
        id: 'documentation',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Documentations',
        field: 'customer_documentations_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: ACCOUNT_ROLE_GROUPS,
    },
    {
        id: 'boards',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Boards',
        field: 'customer_boards_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: NON_GUEST_ROLE_GROUPS,
    },
    {
        id: 'vault',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Vault',
        field: 'customer_vault_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: ACCOUNT_ROLE_GROUPS,
    },
    {
        id: 'finance',
        category: USER_SYSTEM_FEATURE_CATEGORIES.COMPONENT,
        label: 'Finances',
        field: 'customer_finances_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.USER,
        roleGroups: NON_GUEST_ROLE_GROUPS,
        forcedForRoleGroups: ['service_provider'],
    },
    {
        id: 'cms',
        category: USER_SYSTEM_FEATURE_CATEGORIES.EXTENSION,
        label: 'CMS',
        field: 'customer_cms_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.ADMIN,
        roleGroups: ['employee', 'service_provider'],
    },
    {
        id: 'insights',
        category: USER_SYSTEM_FEATURE_CATEGORIES.EXTENSION,
        label: 'Insights',
        field: 'customer_server_monitoring_enabled',
        activation: USER_SYSTEM_FEATURE_ACTIVATION.ADMIN,
        roleGroups: ACCOUNT_ROLE_GROUPS,
    },
]);

export function getUserSystemFeatures(category, roleGroup) {
    return USER_SYSTEM_FEATURES.filter((feature) => (
        feature.category === category
        && feature.roleGroups.includes(roleGroup)
    ));
}

export function isUserSystemFeatureVisible(field, roleGroup) {
    return USER_SYSTEM_FEATURES.some((feature) => (
        feature.field === field
        && feature.roleGroups.includes(roleGroup)
    ));
}

export function isUserSystemFeatureForced(feature, roleGroup) {
    return Array.isArray(feature && feature.forcedForRoleGroups)
        && feature.forcedForRoleGroups.includes(roleGroup);
}
